<template>
  <bill-define :type="type" :options="options"></bill-define>
</template>

<script>
import BillDefine from './component/BillDefine'
export default {
  name: 'paymentDefine',
  components: {BillDefine},
  data () {
    return {
      type: 1,
      options: [
        {
          value: 'subcontract',
          label: '分包款'
        }, {
          value: 'commission',
          label: '提成'
        }
      ]
    }
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/paymentDefine.vue